import React from "react";
import { Box, Typography, Paper, Grid, Stack } from "@mui/material";
import ArrowActive from "../../assets/icons/ArrowActive.svg";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const hasPermission = (userPermissions, screenName) => {
  const permission = userPermissions?.find(
    (permission) =>
      permission?.screen?.name === screenName && permission?.screen?.active
  );

  if (permission?.active) {
    if (permission) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
};

const MastersContent = () => {
  const navigate = useNavigate();
  const userData = useSelector((state) => state?.user?.userData);
  const UserMaster = [
    {
      id: "1",
      name: "Company Admin Master",
      path: "/masters/companyadminmaster",
      active:
        userData?.role?.name === "COMPANY_ADMIN"
          ? true
          : hasPermission(userData?.userRolePermission, "Company_Admin_Master"),
    },
    {
      id: "2",
      name: "Management Master",
      path: "/masters/managementadminmaster",
      active:
        userData?.role?.name  === "COMPANY_ADMIN"
          ? true
          : hasPermission(
              userData?.userRolePermission,
              "Management_User_Master"
            ),
    },
    {
      id: "3",
      name: "Vessel Admin Master",
      path: "/masters/vesseladminmaster",
      active:
        userData?.role?.name  === "COMPANY_ADMIN"
          ? true
          : hasPermission(userData?.userRolePermission, "Vessel_Admin_Master"),
    },
    {
      id: "4",
      name: "Superintendent Master",
      path: "/masters/superintendentmaster",
      active:
        userData?.role?.name  === "COMPANY_ADMIN"
          ? true
          : hasPermission(
              userData?.userRolePermission,
              "Superintendent_Master"
            ),
    },
    {
      id: "5",
      name: "Vessel Type Master",
      path: "/masters/vesseltypemaster",
      active:
        userData?.role?.name  === "COMPANY_ADMIN"
          ? true
          : hasPermission(userData?.userRolePermission, "Vessel_Type_Master"),
    },
    {
      id: "6",
      name: "Vessel Master",
      path: "/masters/vesselmaster",
      active:
        userData?.role?.name  === "COMPANY_ADMIN"
          ? true
          : hasPermission(userData?.userRolePermission, "Vessel_Master"),
    },
  ];

  const ChecklistMaster = [
    {
      id: "1",
      name: "Checklist Type Master",
      path: "/masters/checklisttypemaster",
      active:
        userData?.role?.name  === "COMPANY_ADMIN"
          ? true
          : hasPermission(
              userData?.userRolePermission,
              "Checklist_Type_Master"
            ),
    },
    {
      id: "2",
      name: "Checklist Master",
      path: "/masters/checklistmaster",
      active:
        userData?.role?.name  === "COMPANY_ADMIN"
          ? true
          : hasPermission(userData?.userRolePermission, "Checklist_Master"),
    },
    {
      id: "3",
      name: "Checklist Question Master",
      path: "/masters/checklistquestionmaster",
      active:
        userData?.role?.name  === "COMPANY_ADMIN"
          ? true
          : hasPermission(
              userData?.userRolePermission,
              "Checklist_Question_Master"
            ),
    },
    {
      id: "3",
      name: "Support Master",
      path: "/masters/supportmaster",
      active:
        userData?.role?.name  === "COMPANY_ADMIN"
          ? true
          : hasPermission(userData?.userRolePermission, "Support_Master"),
    },
    // {
    //   id: "4",
    //   name: "Checklist Grace Period",
    //   path: "/masters/checklistgraceperiod",
    // },
    // {
    //   id: "5",
    //   name: "Defect Master",
    //   path: "/masters/defectmaster",
    // },
  ];

  const PermissionMaster = [
    {
      id: "1",
      name: "Send Notification",
      path: "/masters/sendnotification",
      active:
        userData?.role?.name  === "COMPANY_ADMIN"
          ? true
          : hasPermission(
              userData?.userRolePermission,
              "Notification_Broadcast"
            ),
    },
    {
      id: "2",
      name: "Department Master",
      path: "/masters/departmentmaster",
      active:
        userData?.role?.name  === "COMPANY_ADMIN"
          ? true
          : hasPermission(userData?.userRolePermission, "Department_Master"),
    },
    {
      id: "3",
      name: "Role Master",
      path: "/masters/rolemaster",
      active:
        userData?.role?.name  === "COMPANY_ADMIN"
          ? true
          : hasPermission(userData?.userRolePermission, "Role_Master"),
    },
    {
      id: "4",
      name: "Screen Access Master",
      path: "/masters/screenaccessmaster",
      active:
        userData?.role?.name  === "COMPANY_ADMIN"
          ? true
          : hasPermission(userData?.userRolePermission, "Screen_Access_Master"),
    },
    {
      id: "5",
      name: "Role Permission Master",
      path: "/masters/rolepermissionmaster",
      active:
        userData?.role?.name  === "COMPANY_ADMIN"
          ? true
          : hasPermission(
              userData?.userRolePermission,
              "Role_Permission_Master"
            ),
    },
  ];

  return (
    <Box>
      {/* first paper */}
      {UserMaster.filter((item) => item.active).length !== 0 ? (
        <Paper
          sx={{
            width: "auto",
            height: "auto",
            overflow: "auto",
            borderRadius: "10px",
            mb: "20px",
            padding: "16px",
          }}
        >
          <Box sx={{ mb: "10px" }}>
            <Typography sx={{ fontWeight: "600", fontSize: "20px" }}>
              User Master
            </Typography>
          </Box>
          <Box>
            <Grid container spacing={2}>
              {UserMaster.map((row, index) => {
                return row?.active ? (
                  <Grid item xs={12} md={6} key={row.id}>
                    <Stack direction="row" alignItems="center">
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          width: "100%",
                          backgroundColor: "#F3F6F9",
                          borderRadius: "10px",
                          padding: "15px",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          navigate(row.path);
                        }}
                      >
                        <Box>
                          <Typography
                            sx={{
                              fontSize: "14px",
                              color: "#464E5F",
                              fontWeight: 600,
                            }}
                          >
                            {row.name}
                          </Typography>
                        </Box>
                        <Box>
                          <img src={ArrowActive} alt="" />
                        </Box>
                      </Box>
                    </Stack>
                  </Grid>
                ) : null;
              })}
            </Grid>
          </Box>
        </Paper>
      ) : null}

      {/* second paper */}
      {ChecklistMaster.filter((item) => item.active).length !== 0 ? (
        <Paper
          sx={{
            width: "auto",
            height: "auto",
            overflow: "auto",
            borderRadius: "10px",
            mb: "20px",
            padding: "16px",
          }}
        >
          <Box sx={{ mb: "10px" }}>
            <Typography sx={{ fontWeight: "600", fontSize: "20px" }}>
              Checklist Master
            </Typography>
          </Box>
          <Box>
            <Grid container spacing={2}>
              {ChecklistMaster.map((row, index) => {
                return row?.active ? (
                  <Grid item xs={12} md={6} key={row.id}>
                    <Stack direction="row" alignItems="center">
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          width: "100%",
                          backgroundColor: "#F3F6F9",
                          borderRadius: "10px",
                          padding: "15px",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          navigate(row.path);
                        }}
                      >
                        <Box>
                          <Typography
                            sx={{
                              fontSize: "14px",
                              color: "#464E5F",
                              fontWeight: 600,
                            }}
                          >
                            {row.name}
                          </Typography>
                        </Box>
                        <Box>
                          <img src={ArrowActive} alt="" />
                        </Box>
                      </Box>
                    </Stack>
                  </Grid>
                ) : null;
              })}
            </Grid>
          </Box>
        </Paper>
      ) : null}

      {/* third paper */}

      {PermissionMaster.filter((item) => item.active).length !== 0 ? (
        <Paper
          sx={{
            width: "auto",
            height: "auto",
            overflow: "auto",
            borderRadius: "10px",
            mb: "20px",
            padding: "16px",
          }}
        >
          <Box sx={{ mb: "10px" }}>
            <Typography sx={{ fontWeight: "600", fontSize: "20px" }}>
              Permission Master
            </Typography>
          </Box>
          <Box>
            <Grid container spacing={2}>
              {PermissionMaster.map((row, index) => {
                return row.active ? (
                  <Grid item xs={12} md={6} key={row.id}>
                    <Stack direction="row" alignItems="center">
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          width: "100%",
                          backgroundColor: "#F3F6F9",
                          borderRadius: "10px",
                          padding: "15px",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          navigate(row.path);
                        }}
                      >
                        <Box>
                          <Typography
                            sx={{
                              fontSize: "14px",
                              color: "#464E5F",
                              fontWeight: 600,
                            }}
                          >
                            {row.name}
                          </Typography>
                        </Box>
                        <Box>
                          <img src={ArrowActive} alt="" />
                        </Box>
                      </Box>
                    </Stack>
                  </Grid>
                ) : null;
              })}
            </Grid>
          </Box>
        </Paper>
      ) : null}
    </Box>
  );
};

export default MastersContent;
